var $2eab88da6eb0edda$exports = {};
$2eab88da6eb0edda$exports = {
  "collapse": "\u0637\u064A",
  "expand": "\u062A\u0645\u062F\u064A\u062F"
};
export { $2eab88da6eb0edda$exports as default };